export default __webpack_public_path__ + "static/media/sad.8d438210.png";